var React = require('react');

function Fivestar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36.1093 0.74536C36.4804 0.0181091 37.5196 0.0181087 37.8907 0.74536L48.7596 22.0429C48.9049 22.3277 49.1775 22.5257 49.4932 22.576L73.1071 26.3315C73.9134 26.4598 74.2345 27.4481 73.6576 28.0258L56.761 44.944C56.5352 45.1702 56.431 45.4907 56.4808 45.8065L60.2061 69.4251C60.3333 70.2316 59.4926 70.8424 58.7649 70.4722L37.4534 59.6307C37.1685 59.4857 36.8315 59.4857 36.5466 59.6307L15.2351 70.4722C14.5074 70.8424 13.6667 70.2316 13.7939 69.4251L17.5192 45.8065C17.569 45.4907 17.4648 45.1702 17.239 44.944L0.342431 28.0258C-0.234537 27.4481 0.0865769 26.4598 0.892923 26.3315L24.5068 22.576C24.8225 22.5257 25.0951 22.3277 25.2404 22.0429L36.1093 0.74536Z","fill":"#262626"}));
}

Fivestar.defaultProps = {"viewBox":"0 0 74 71","fill":"none"};

module.exports = Fivestar;

Fivestar.default = Fivestar;
